import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js";

// Connects to data-controller="tooltip"
export default class extends Controller {
  static targets = ["content"];

  connect() {
    tippy(this.element, {
      content: this.contentTarget.innerHTML,
      allowHTML: true
    });
  }
}
